import React, { useState, useCallback } from "react"
import TokenInput from "./components/TokenInput"
import TokenDetails from "./components/TokenDetails"
import { fetchTokenMetadata } from "./utils/web3"
import { decodeBase64 } from "./utils/decodeBase64"
import { convertSVGToPNG } from "./utils/convertSVGtoPNG"
import { createSnowEffect } from "./utils/snowEffect"

function App() {
  const [metadata, setMetadata] = useState(null)
  const [pngImage, setPngImage] = useState(null)

  const handleFetchMetadata = useCallback(async (tokenId) => {
    try {
      const rawMetadata = await fetchTokenMetadata(tokenId)
      console.log("Raw metadata fetched")
      console.log("Starting decode of metadata")
      const decodedMetadata = decodeBase64(rawMetadata)
      console.log("Metadata decoded")

      if (!decodedMetadata) {
        throw new Error("Failed to decode metadata")
      }

      setMetadata(decodedMetadata)

      // Convert SVG to PNG
      if (decodedMetadata.image) {
        console.log("Starting SVG to PNG conversion")
        try {
          // Create a temporary image element
          const tempImg = document.createElement("img")
          tempImg.crossOrigin = "anonymous"

          // Create a promise to handle the image loading
          const loadImage = new Promise((resolve, reject) => {
            tempImg.onload = () => resolve(tempImg)
            tempImg.onerror = () => reject(new Error("Failed to load image"))
            tempImg.src = decodedMetadata.image
          })

          // Wait for image to load then convert to PNG
          const loadedImg = await loadImage
          const pngData = await convertSVGToPNG(loadedImg)
          console.log("PNG conversion complete")
          setPngImage(pngData)
        } catch (err) {
          console.error("Error converting to PNG:", err)
          // Show the original SVG as fallback
          setPngImage(decodedMetadata.image)
        }
      }
    } catch (err) {
      console.error(err)
      throw err
    }
  }, [])

  const handleDownload = async () => {
    if (!pngImage) return

    try {
      createSnowEffect() // Add snow effect
      const link = document.createElement("a")
      link.download = `${metadata?.name || "image"}.png`
      link.href = pngImage
      link.click()
    } catch (error) {
      console.error("Error downloading image:", error)
    }
  }

  return (
    <div className="app-wrapper">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6">
            <div className="card shadow-lg border-0 rounded-4 bg-white">
              <div className="card-body p-4">
                <h4 className="text-center mb-4 pixel-font">
                  Lazy Birb PNG Converter
                </h4>
                <TokenInput onFetchMetadata={handleFetchMetadata} />
                <TokenDetails
                  metadata={metadata}
                  image={pngImage}
                  onDownload={handleDownload}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default App
